export const BONUS_SOURCES = [
    { key: 'transactional', labelKey: 'NSBonusMode.sourceTransactional', alwaysAvailable: true },
    { key: 'birthday', labelKey: 'NSBonusMode.sourceBirthday', configField: 'birthday_bonus.enabled' },
    { key: 'cross', labelKey: 'NSBonusMode.sourceCross', toggleKey: 'cross_marketing' },
    { key: 'review', labelKey: 'NSBonusMode.sourceReview', toggleKey: 'whatsapp_review' },
    { key: 'referral', labelKey: 'NSBonusMode.sourceReferral', toggleKey: 'referrals' },
    { key: 'sale', labelKey: 'NSBonusMode.sourceSale', alwaysAvailable: true },
    { key: 'auto_mailing', labelKey: 'NSBonusMode.sourceAutoMailing', toggleKey: 'mass_notifications' },
    { key: 'mailing', labelKey: 'NSBonusMode.sourceMailing', alwaysAvailable: true },
    { key: 'manual', labelKey: 'NSBonusMode.sourceManual', alwaysAvailable: true },
    { key: 'certificate', labelKey: 'NSBonusMode.sourceCertificate', toggleKey: 'certificates' },
    { key: 'revert', labelKey: 'NSBonusMode.sourceRevert', alwaysAvailable: true },
];

export function isSourceAvailable(source, config) {
    if (source.alwaysAvailable) return true;
    if (!config) return false;

    // Check access_toggles first (canonical source for feature availability)
    if (source.toggleKey) {
        return !!config.access_toggles?.[source.toggleKey]?.enabled;
    }

    // Fallback to config field path (for features without access toggles, e.g. birthday)
    if (source.configField) {
        const parts = source.configField.split('.');
        let value = config;
        for (const part of parts) {
            value = value?.[part];
            if (value === undefined) return false;
        }
        return !!value;
    }

    return false;
}
